export const MINIMUM_DESCRIPTION_LENGTH = 10;
export const YOUTUBE_EMBED_URL = 'https://www.youtube.com/embed/';
export const ALL_SHADE_HEADER_TITLE = 'Select a shade';
export const DESCRIPTION_TAB = 'Description';
export const INGREDIENTS_TAB = 'Ingredients';
export const HOW_TO_USE_TAB = 'How To Use';
export const PRODUCT_DETAILS_TITLE = 'Product Description';
export const VIEW_ALL_PRODUCTS = 'VIEW ALL PRODUCTS';
export const CUSTOMERS_ALSO_VIEWED = 'Customers also Viewed';
export const CUSTOMERS_ALSO_BOUGHT = 'Customers also Bought';
export const OFFERS_SECTION_ID = 'product-offers-section';
export const OFFERS_TAG_NAME = 'offers';
export const INCLUSIVE_TAX_TEXT = 'inclusive of all taxes';
export const ALL_SIZE_HEADER_TITLE = 'Select a Size';
export const CAV_SECTION_ID = 'cav-products-section';
export const VIEW_SIMILAR_TEXT = 'VIEW SIMILAR';
export const CAB_SECTION_ID = 'cab-products-section';
export const SIZE_SELECT_TEXT = 'TAP TO SELECT SIZE';
export const RATING_POPUP_CLASS = 'ratingSplitPopup';
export const REVIEW_QA_SECTION = 'reviewQ&ASection';
export const SIZE = {
  small: 'small',
  medium: 'medium',
  large: 'large',
  title: 'title',
};
export const FONT_NORMAL = 'normal';
export const FONT_BOLD = 'bold';

export const BORDER_NORMAL = 'normal';
export const BORDER_BIG = 'big';

export const DEFAULT_SNACKBAR = { id: '', msg: '', isError: false, status: false, isCart: false };

export const QUESTION_AND_ANS_ID = 'questionSection';

export const REVIEW_SECTION_ID = 'reviewSection';
export const DEFAULT_SHIPPING_MESSAGE = 'A shipping charge of Rs.500 will be applied on orders below Rs.5,000 for delivery outside India.';
export const MediaTypes = {
  VIDEO: 'video',
  YOUTUBE_VIDEO: 'youtube video',
  IMAGE: 'image',
};
export const QC_DOMAIN = 'quickCommerce';
export const QC_INTERNAL_SLUG = 'nykaa';
